var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWithlessLogoDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 47,
    viewBox: "0 0 60 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 8.13727,
    width: 15.275,
    height: 6.17153,
    fill: "#07132B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 14.7246,
    y: 17.4235,
    width: 15.275,
    height: 6.17153,
    fill: "#07132B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3613 15.9288V0.500003H28.4713V15.9288H22.3613Z",
    fill: "#07132B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5273 31.3577V15.9288H37.6374V31.3577H31.5273Z",
    fill: "#07132B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.88159 46.7226H4.44298L6.14401 41.004L7.84504 46.7226H9.40643L12.288 37.6702H10.3204L8.60669 43.3504L6.93105 37.6702H5.36966L3.69402 43.3376L1.9803 37.6702H0L2.88159 46.7226Z",
    fill: "#07132B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0137 39.4619V46.7226H15.0067V39.4619H13.0137Z",
    fill: "#07132B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5782 37.6702H15.7715V39.4269H18.5769V46.7226H20.5699V39.4269H23.3753V37.6702H20.5686V39.4265H18.5782V37.6702Z",
    fill: "#07132B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1406 46.7226H26.1336V42.9401H29.688V46.7226H31.6937V37.6702H29.688V41.1963H26.1336V37.6702H24.1406V46.7226Z",
    fill: "#07132B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.0547 44.9536H35.0473V46.7226H39.021V44.9532H35.0477V37.6702H33.0547V44.9536Z",
    fill: "#07132B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2582 46.7226H39.8223L41.8137 46.7226V44.9809H39.8223V37.6702H46.1948V39.4012H41.8153V41.2604H45.8139V42.9401H41.8153V44.9788H46.2582V46.7226Z",
    fill: "#07132B"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M49.74 46.8636C51.898 46.8636 53.1801 45.8251 53.1801 44.0941C53.1801 40.7988 48.9783 41.581 48.9783 40.0038C48.9783 39.5038 49.3972 39.2345 50.1081 39.2345C50.7936 39.2345 51.3267 39.5038 51.8599 40.068L53.1547 38.7729C52.4819 38.0164 51.4029 37.5292 50.1462 37.5292C48.2928 37.5292 46.998 38.5293 46.998 40.1962C46.998 43.376 51.1998 42.5683 51.1998 44.2736C51.1998 44.8121 50.7047 45.1455 49.8669 45.1455C48.9275 45.1455 48.2547 44.7736 47.6835 44.0941L46.3887 45.3891C47.2646 46.3892 48.2674 46.8636 49.74 46.8636Z",
    fill: "#07132B"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5603 46.8636C58.7183 46.8636 60.0004 45.8251 60.0004 44.0941C60.0004 40.7988 55.7986 41.581 55.7986 40.0038C55.7986 39.5038 56.2175 39.2345 56.9284 39.2345C57.6139 39.2345 58.147 39.5038 58.6802 40.068L59.975 38.7729C59.3022 38.0164 58.2232 37.5292 56.9665 37.5292C55.1131 37.5292 53.8183 38.5293 53.8183 40.1962C53.8183 43.376 58.0201 42.5683 58.0201 44.2736C58.0201 44.8121 57.525 45.1455 56.6872 45.1455C55.7478 45.1455 55.075 44.7736 54.5038 44.0941L53.209 45.3891C54.0849 46.3892 55.0877 46.8636 56.5603 46.8636Z",
    fill: "#07132B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithlessLogoDark);
export default __webpack_public_path__ + "static/media/withless-logo-dark.467cc4c83e765461577ea08fafc73203.svg";
export { ForwardRef as ReactComponent };